import axios from 'axios';

export const COURSE = 'course';
export const JOBS = 'front/jobs';

export function putScore(courseGuid, averageId, score) {
  return axios.put(`front/courses/${courseGuid}/gradebook/average`, { id: averageId, score_custom: score });
}

export function postScore(courseGuid, periodId, personId, score) {
  return axios.post(`front/courses/${courseGuid}/gradebook/average`, { period_id: periodId ? periodId : 'global', score_custom: score, person_id: personId });
}

export function deleteScore(courseGuid, averageId) {
  const data = averageId ? { id: averageId } : {};

  return axios.delete(`front/courses/${courseGuid}/gradebook/average`, { data });
}

// export function getLessonItemGradebook(courseGuid, lessonItemGuid) {
//   return axios.get(`${COURSE}/${courseGuid}/lessonItemGuid/${lessonItemGuid}/gradebook/average/`);
// }

export async function getLessonItemGradebook(courseGuid, lessonItemGuid) {
  // Simulamos un pequeño delay para imitar la llamada a la red
  await new Promise((resolve) => setTimeout(resolve, 100));

  // Datos mockeados
  return {
    data: {
      data: {
        name: 'La criba de Eratóstenes',
        evaluation_period: 'Trimestre 1',
        unit: 'Los números primos',
        is_evaluable: 1,
        scale_name: 'Estándar Numérica (0-10',
        category_name: 'Razonamiento lógico',
        deliver_at: '2024-03-20',
      },
    },
  };
}

export async function getHeadersGradebook(courseGuid, usersGuid) {
  let customized = usersGuid ? usersGuid : null;
  return axios.get(`front/courses/${courseGuid}/gradebook/headers`, { params: { ...(customized && { customized_by: customized }) } });
}

export async function getModelsGradebook(courseGuid) {
  return axios.get(`front/courses/${courseGuid}/models`);
}

export async function getGradebook(courseGuid, customizedBy) {
  // Simulamos un pequeño delay para imitar la llamada a la red
  // await new Promise((resolve) => setTimeout(resolve, 100));
  // // Datos mockeados
  // return {
  //   data: {
  //     data: {
  //       config: {
  //         order_by: 'name',
  //         show_unpublished_activities: false,
  //         enable_grade_modification_global: false,
  //         enable_grade_modification_average: false,
  //         late_count: false,
  //       },
  //     },
  //   },
  // };

  let customized = customizedBy ? customizedBy : null;
  return axios.get(`front/courses/${courseGuid}/gradebooks`, { params: { ...(customized && { customized_by: customized }) } });

}

export function putConfigGradebook(courseGuid, data) {
  return axios.put(`front/courses/${courseGuid}/gradebook/config`, data);
}

export function publishScoreItem(courseGuid, lessonItemGuid, periodId) {
  const data = lessonItemGuid ? { lesson_item_id: lessonItemGuid } : { period_id: periodId ? periodId : 'null' };

  return axios.put(`front/courses/${courseGuid}/gradebook/publish`, data);
}

export function unpublishScoreItem(courseGuid, lessonItemGuid, periodId) {
  const data = lessonItemGuid
    ? { lesson_item_id: lessonItemGuid }
    : { period_id: periodId ? periodId : 'null' };

  return axios.put(`front/courses/${courseGuid}/gradebook/unpublish`, data);
}
